module.exports = __webpack_public_path__ + "static/masayuki-and-yukiko-yoshida-004db5ac2a09f8726fc2a71a92f86364.jpg";